// File: frontend/src/config/istochnikiObrashcheniy.js
// Version: 1.0 (quick-260911-27v)
// Date: 2026-09-11
// Назначение: ЕДИНСТВЕННЫЙ держатель двух вопросов, общих ДВУМ экранам списка
//             обращений (прежнему `LeadsPage` и новому `FitenkoObrashcheniya`):
//             «что показать вместо синтетической почты» и «как назвать источник».
//
// 🔴 ЗАЧЕМ ОТДЕЛЬНЫЙ ФАЙЛ, А НЕ «ПЕРЕНЕСТИ ВМЕСТЕ С ЭКРАНОМ» (отступление от
//    плана, названо в SUMMARY). План велел перенести обе функции в новый экран и
//    «второго словаря источников не заводить». Буквальный перенос дал бы одно из
//    двух: либо копию в двух экранах (два держателя), либо ввоз из нового экрана
//    в старый при том, что старый УЖЕ ввозит новый, — кольцо ввоза. Держатель
//    один, и он здесь; кольца нет; ни один экран не зависит от другого.
//
// 🔴 КЛАСС ОФОРМЛЕНИЯ ЗДЕСЬ НЕ ЖИВЁТ. Прежние `src-voice`/`src-chat` объявлены в
//    `LeadsPage.css` БЕЗ рубежа арендатора; новый экран красит источник своим
//    правилом раздела 11. Общее у экранов — ОТВЕТ («звонок», «веб-чат»), а не
//    его вид.

// Голосовые и чат-обращения получают синтетическую почту вида
// `chat_/voice_<номер>@<домен-арендатора>` — она нужна для склейки дублей и
// НИКОГДА не является настоящим адресом. Отбор не зависит от домена.
export const displayEmail = (e) =>
    (e && /^(chat|voice)_[\d+]+@/i.test(e)) ? '—' : (e || '—');

// Источник → значок и подпись. Незнакомый источник возвращается САМ СОБОЙ:
// правдоподобная подстановка была бы неотличима от опознания.
export const sourceMeta = (s) => {
    const v = (s || '').toLowerCase();
    if (v.includes('voice') || v.includes('phone')) return { icon: '📞', label: 'Phone (Sofia)', cls: 'src-voice' };
    if (v.includes('chat')) return { icon: '💬', label: 'Web chat (Sofia)', cls: 'src-chat' };
    if (v.includes('web') || v.includes('site')) return { icon: '🌐', label: 'Website', cls: 'src-web' };
    return { icon: '📋', label: s || '—', cls: 'src-other' };
};
